import { isTouchDevice } from '../utils'

const Pointer = new function() {
    const scrollerSelector = '.na-layout'

    let el = null
    let hoverElement = null
    let triggers = []
    let clientX = 0
    let clientY = 0

    const duration = 1

    this.init = () => {
        if (isTouchDevice) return

        el = document.querySelector('.na-pointer')

        if(el) {
            // Set triggers
            this.setupTriggers()
    
            // On mouse move
            window.addEventListener('mousemove', (e) => {
                clientX = e.clientX
                clientY = e.clientY
            })
            document.addEventListener("mousemove", this.unveilPointer)
    
            // On scroll
            document.querySelector(scrollerSelector).addEventListener('scroll', this.onScroll)
        }
    }

    // Setup triggers
    this.setupTriggers = () => {
        const elements = document.querySelectorAll('[data-pointer]')
        elements.forEach(element => triggers.push(element))
        triggers.forEach(trigger => {
            trigger.addEventListener('mouseover', () => {
                this.show(trigger.dataset.pointer)
            })
            trigger.addEventListener('mouseleave', () => {
                this.hide()
            })
        })
    }

    // On mouse move
    this.unveilPointer = () => {
        document.removeEventListener("mousemove", this.unveilPointer)
        gsap.set(el, {
            x: clientX,
            y: clientY,
        })
        this.render()
    }

    this.render = () => {
        gsap.to(el, {
            x: clientX,
            y: clientY,
            duration: duration,
            ease: 'power4.out',
        })
        requestAnimationFrame(this.render)
    }

    // On scroll
    this.onScroll = () => {
        const newHoverElement = document.elementFromPoint(clientX, clientY)
        if (newHoverElement && newHoverElement !== hoverElement) {
            hoverElement = newHoverElement
            hoverElement.dataset.pointer ? this.show(hoverElement.dataset.pointer) : this.hide()
        } else {
            return
        }
    }

    // Show pointer
    this.show = (pointer) => {
        el.classList.add('is-visible')
        el.classList.add('pointer-' + pointer)

        let img = '#' + pointer;
        if(el.querySelector(img)) {
            el.querySelector(img).classList.add('is-active');
        }

        gsap.to(el, {
            scale: 1,
            ease: 'power2.out',
            duration: .3,
        })
        gsap.to(el, {
            opacity: 1,
            duration: .2,
        })
    }

    // Hide pointer
    this.hide = () => {
        let imgs = document.querySelectorAll('.na-artists-thumbnail');
        if(imgs) {
            imgs.forEach((img) => {
                img.classList.remove('is-active');
            })
        }

        el.className = ''
        el.classList.add('na-pointer')

        gsap.to(el, {
            scale: 0,
            ease: 'power2.out',
            duration: .3,
        })
        gsap.to(el, {
            opacity: 0,
            duration: .2,
        })
    }
}

export default Pointer